import _ from "lodash";
import { format } from "date-fns";
import { mapUrl, mapUrlTestMultipleCoords } from "util/geolocation";
import { LocationIcon } from "./LocationIcon";
import { criaGrafico } from "OkReport/OkReportGerador";
import { ArrowDownRed, ArrowDownYellow, ArrowUpRed, ArrowUpYellow, HyphenGreen } from "./arrow";

export function painel(conteudo, config, configTable) {
    let rows = [];
    let defaultConfig = {
        style: 'table',
        margin: [0, 0, 0, 1],
        layout: 'noBorders'
    };
    if (Array.isArray(conteudo)) {
        if (Array.isArray(conteudo[0])) {
            rows = conteudo;
        } else {
            rows.push(conteudo);
        }
    } else {
        defaultConfig = { ...defaultConfig, widths: ['*'] }
        rows.push([conteudo])
    }


    if (config) {
        defaultConfig = { ...defaultConfig, ...config }
    }

    return {
        // margin: defaultConfig.margin,
        // style: defaultConfig.style,
        table: {
            body: rows,
            widths: defaultConfig.widths,
            ...configTable
        },
        // layout: defaultConfig.layout,
        ...defaultConfig
    }
}


export default class TableReportHelper {
    constructor(data) {
        this.data = data;

        this.textStyle = "cellValor";
        this.titleStyle = "cellTitulo";

        this.dateFormat = "dd/MM/yyyy";
        this.digits = 2;
        this.separator = ", ";

        this.conformidadeColors = {
            Ótimo: "#0ee650",
            Bom: "#0ee650",
            Regular: "#f7f71e",
            Ruim: "#f0483a",
        };
    }

    /**
     * Cria um helper para dados locais (ex: linhas da tabela).
     */
    helper(data) {
        return new TableReportHelper(data);
    }

    /**
     * Insere uma quebra de página.
     */
    pageBreak(props) {
        return {
            text: "", pageBreak: "after", ...props
        };
    }

    space(height = 20) {
        return { text: "", margin: [0, 0, 0, height] };
    }

    /**
     * Recebe um array com as linhas e cria uma tabela.
     */
    panel(rows, props, tableProps) {
        if (!_.isEmpty(rows)) {
            return painel(
                rows,
                {
                    widths: Array(rows[0].length).fill("*"),
                    ...props,
                },
                {
                    dontBreakRows: true,
                    ...tableProps,
                }
            );
        } else {
            return this.empty();
        }
    }
    panelBreakRows(rows, props, tableProps) {
        if (!_.isEmpty(rows)) {
            return painel(
                rows,
                {
                    widths: Array(rows[0].length).fill("*"),
                    ...props,
                },
            );
        } else {
            return this.empty();
        }
    }

    unbreakable(content, props) {
        return { stack: [content], unbreakable: true, ...props };
    }

    /**
     * Recebe as células criadas por 'cell()' e cria uma linha da tabela.
     *
     * Os resultados deve ser armazenados em um array e passados para o método 'panel()'.
     */
    row(...cells) {
        const result = [];

        for (const cell of cells) {
            // Expande a célula em múltiplas colunas se for um array.
            if (_.isArray(cell)) {
                result.push(...cell);
            } else if (!_.isNil(cell)) {
                result.push(cell);
            }
        }

        return result;
    }

    /**
     * Cria uma cálula da tabela, ou múltiplas se o prop 'colSpan' for especificado.
     *
     * O resultado deve ser passado como um dos parâmetros do método 'row()'.
     */
    cell(props) {
        const result = [props];

        if (props.colSpan) {
            // Se a célula ocupar múltiplas colunas, preenche com espaços vazios.
            // Este é um requerimento do pdfmake.
            result.push(...this.empty(props.colSpan - 1));
        }

        return result;
    }

    /**
     * Cria um array com uma ou mais células vazias.
     *
     * O resultado deve ser passado como um dos parâmetros do método 'row()'.
     */
    empty(colSpan = 1, props) {
        return Array(colSpan).fill({ style: this.textStyle, text: "", ...props });
    }

    /**
     * Cria uma célula com formato de título.
     *
     * O resultado deve ser passado como um dos parâmetros do método 'row()'.
     */
    title(content, props) {
        return this.cell({ style: this.titleStyle, text: content, ...props });
    }

    /**
     * Cria uma célula com formato de texto simples.
     *
     * O resultado deve ser passado como um dos parâmetros do método 'row()'.
     */
    text(content, props) {
        return this.cell({ style: this.textStyle, text: content, ...props });
    }

    /*
     * Cria uma célula com formato de texto simples
     * Esse helper foi criado para renderizar uma mensagem personalizada caso não houver nenhuma informação
     * passada na descrição da imagem  
    */
    conditionalImageText(content, props) {
        return this.cell(
            {
                style: this.textStyle,
                text: content
                    ? content
                    : "Nenhuma descrição foi inserida.",
                ...props
            }
        )
    }

    /**
     * Cria uma célula contendo o número formatado.
     * Aceita o prop 'digits', que são o número de casas decimais.
     *
     * O resultado deve ser passado como um dos parâmetros do método 'row()'.
     */
    number(content, props) {
        const digits = _.get(props, "digits");
        const suffix = _.get(props, "suffix", "");

        return this.text(this.formatNumber(content, digits) + suffix, props);
    }

    /**
     * Cria uma célula contendo a data formatada.
     *
     * O resultado deve ser passado como um dos parâmetros do método 'row()'.
     */
    date(content, props) {
        return this.text(this.formatDate(content), props);
    }

    /**
     * Cria uma célula contendo uma lista de valores.
     *
     * O resultado deve ser passado como um dos parâmetros do método 'row()'.
     */
    list(content, props) {
        console.log("CONTENT APENAS STRING!!!!! ", content);
        return this.text(_.join(content, this.separator), props);
    }

    listFrentes(content, props) {
        let newArrayOfStrings = []
        content.forEach((c) => {
            if (typeof c === 'object') {
                newArrayOfStrings.push(c.frente)
            } else {
                newArrayOfStrings.push(c)
            }
        })

        let finalResult = this.checkForDuplicatedValues(newArrayOfStrings)

        return this.text(finalResult, props)
    }

    checkForDuplicatedValues(content, props) {
        if (content) {
            // const filterFrentesToAvoidRepetitions = content.filter((c) => )
            const hasBeenSeen = new Set();
            const uniqueByUid = content.filter((item) => {
                if (hasBeenSeen.has(item)) {
                    return false
                }
                hasBeenSeen.add(item)
                return true
            })
            let frentes = ""
            let hasSeparator = uniqueByUid.length > 1 ? this.separator : ""
            uniqueByUid.forEach((c) => {
                frentes += c + hasSeparator
            })
            return this.text(frentes, props)
        }
    }

    image(data, props) {
        if (!_.isEmpty(data)) {
            return this.cell({
                image: data,
                style: this.textStyle,
                ...props,
            });
        } else {
            return this.empty();
        }
    }

    arrowUp(status, props = {}) {
        let arrow;

        if (status === "Ruim") {
            arrow = ArrowUpRed;
        } else if (status === "Regular") {
            arrow = ArrowUpYellow;
        }

        return this.image(arrow, {
            width: 24,
            style: this.textStyle,
            ...props,
        });
    }

    hyphen(props = {}) { return this.image(HyphenGreen, { width: 24, style: this.textStyle, ...props, }) }

    arrowDown(status, props = {}) {
        let arrow;

        if (status === "Ruim") {
            arrow = ArrowDownRed;
        } else if (status === "Regular") {
            arrow = ArrowDownYellow;
        }

        return this.image(arrow, {
            width: 24,
            style: this.textStyle,
            ...props,
        });
    }

    location(coordinates, props) {
        if (!_.isEmpty(coordinates)) {
            return {
                image: LocationIcon,
                link: mapUrl(coordinates),
                width: 20,
                style: this.textStyle,
                ...props,
            };
        } else {
            return this.empty();
        }
    }

    // TODO: mover campos específicos da aplicação para outra classe.
    conformidade(value, status, props) {
        return this.number(value, { fillColor: this.conformidadeColors[status], ...props });
    }

    async chart(type, chartProps, props) {
        const chart = await criaGrafico(
            {
                type: type,
                ...chartProps,
            },
            "chart"
        );

        if (chart) {
            return this.image(chart["chart"], props);
        }
    }

    async pieChart(chartProps, props) {
        return this.chart("PieChart", chartProps, props);
    }
    async gaugeChart(chartProps, props) {
        return this.chart("GaugeChart", chartProps, props);
    }

    async barChart(chartProps, props) {
        return this.chart("BarChart", chartProps, props);
    }
    async barChartMult(chartProps, props) {
        return this.chart("BarChartMult", chartProps, props);
    }

    textField(field, props) {
        if (props === "imagem") return this.conditionalImageText(this.get(field), props)

        return this.text(this.get(field), props);
    }

    numberField(field, props) {
        return this.number(this.get(field), props);
    }

    dateField(field, props) {
        return this.date(this.get(field), props);
    }

    listField(field, props) {
        return this.list(this.get(field), props);
    }

    imageField(field, props) {
        return this.image(this.get(field), props);
    }

    locationField(field, props) {
        return this.location(this.get(field), props);
    }

    coordinatesValue(field) {
        console.log("field ", field);
        const loc = this.get(field)
        console.log("loc ", loc);

        return
    }


    async locationImageField(field, props) {
        const loc = this.get(field)
        const key = "AIzaSyDmb_OFlZGDaR7vuzmEOHaplQsn_N9sQQk"

        let staticMapUrl = ""
        let getImage = ""

        async function getBase64ImageFromUrl(url) {
            return new Promise(async (resolve, reject) => {
                try {
                    const response = await fetch(url);
                    const blob = await response.blob();
                    const reader = new FileReader();
                    reader.onloadend = () => resolve(reader.result);
                    reader.onerror = reject();
                    reader.readAsDataURL(blob);
                } catch (error) {
                    reject(error)
                }
            });
        }
        staticMapUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${loc.lat},${loc.lng}&zoom=15&size=200x200&maptype=satellite&markers=color:red%7C${loc.lat},${loc.lng}&key=${key}`

        try {
            getImage = await getBase64ImageFromUrl(staticMapUrl)
        } catch (error) {
            console.log("error ", error);
        }

        if (!_.isEmpty(loc) && getImage) {
            return {
                image: getImage,
                link: mapUrl(loc),
                width: 100,
                style: this.textStyle,
                ...props,
            };
        } else {
            return {
                image: LocationIcon,
                link: mapUrl(loc),
                width: 50,
                style: this.textStyle,
                ...props,
            };
        }
    }

    async getLocationImageByGeolocationArray(array) {
        const key = "AIzaSyDmb_OFlZGDaR7vuzmEOHaplQsn_N9sQQk"

        let markers = ""

        function verifyUndefined(array) {
            if (Array.isArray(array)) {
                const coordinatesArray = array.filter((value) => { return value !== null })
                return coordinatesArray
            }
            return false
        }

        const verifiedValues = verifyUndefined(array)
        if (verifiedValues && verifiedValues.length > 0) {
            markers = verifiedValues.map((location) => `markers=color:red%7C${location.lat},${location.lng}`).join('&');
        } else {
            markers = ""
        }

        let staticMapUrl = ""
        let getImage = ""

        async function getBase64ImageFromUrl(url) {
            return new Promise(async (resolve, reject) => {
                try {
                    const response = await fetch(url);
                    const blob = await response.blob();
                    const reader = new FileReader();
                    reader.onloadend = () => resolve(reader.result);
                    reader.onerror = reject;
                    reader.readAsDataURL(blob);
                } catch (error) {
                    reject(error)
                }
            });
        }

        staticMapUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${markers}&markers=scale:1&zoom=15&size=650x650&maptype=satellite&${markers}&key=${key}`;

        try {
            getImage = await getBase64ImageFromUrl(staticMapUrl)
        } catch (error) {
            console.log("error ", error);
        }

        if (!_.isEmpty(array) && getImage) {
            return {
                image: getImage,
                link: mapUrlTestMultipleCoords(verifyUndefined(array)),
                width: 550,
                style: this.textStyle,
            };
        } else {
            return {
                style: 'table',
                layout: "noBorders",
                table: {
                    body: [
                        [
                            {
                                image: LocationIcon,
                                link: mapUrlTestMultipleCoords(verifyUndefined(array)),
                                width: 50,
                                style: this.textStyle,
                                alignment: 'center',
                            }
                        ],
                        [
                            { text: "Sem conexão com a internet", style: this.textStyle, alignment: 'center' }
                        ]
                    ], widths: ["*"]
                }
            }
        }

    }

    async locationImageFieldHeaderOnly(coletas, image, props) {
        const key = "AIzaSyDmb_OFlZGDaR7vuzmEOHaplQsn_N9sQQk"

        let markers = ""

        if (!coletas && !image) {
            return null
        }

        // função que criei para retornar apenas coordenadas que não são nulas
        function verifyUndefined(array) {
            if (Array.isArray(array)) {
                const coordinatesArray = array.filter((value) => { return value.georeferencia !== null })
                return coordinatesArray
            }
            return false
        }

        if (Array.isArray(coletas)) {
            const verifiedValues = verifyUndefined(coletas)
            if (verifiedValues && verifiedValues.length > 0) {
                markers = verifiedValues.map((location) => `markers=color:red%7C${location.georeferencia.lat},${location.georeferencia.lng}`).join('&');
            } else {
                markers = ""
            }
        } else {
            markers = `markers=color:red%7C${coletas.lat},${coletas.lng}`
        }

        if (image) {
            const imageMarkers = image.map((img) => `markers=color:blue%7C${img.georeferencia.lat},${img.georeferencia.lng}`).join('&');
            markers = markers ? `${markers}&${imageMarkers}` : imageMarkers
        }

        let staticMapUrl = ""
        let getImage = ""

        async function getBase64ImageFromUrl(url) {
            return new Promise(async (resolve, reject) => {
                try {
                    const response = await fetch(url);
                    const blob = await response.blob();
                    const reader = new FileReader();
                    reader.onloadend = () => resolve(reader.result);
                    reader.onerror = reject;
                    reader.readAsDataURL(blob);
                } catch (error) {
                    reject(error)
                }
            });
        }

        staticMapUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${markers}&zoom=15&size=400x300&maptype=satellite&${markers}&key=${key}`;

        try {
            getImage = await getBase64ImageFromUrl(staticMapUrl)
        } catch (error) {
            console.log("error ", error);
        }

        if (!_.isEmpty(coletas) && getImage) {
            return {
                image: getImage,
                link: mapUrlTestMultipleCoords(verifyUndefined(coletas)),
                width: 200,
                style: this.textStyle,
                ...props,
            };
        } else {
            return {
                style: 'table',
                layout: "noBorders",
                table: {
                    body: [
                        [
                            {
                                image: LocationIcon,
                                link: mapUrlTestMultipleCoords(verifyUndefined(coletas)),
                                width: 50,
                                style: this.textStyle,
                                alignment: 'center',
                                ...props,
                            }
                        ],
                        [
                            { text: "Sem conexão com a internet", style: this.textStyle, alignment: 'center' }
                        ]
                    ], widths: ["*"]
                }
            }
        }
    }

    conformidadeField(field, status, props) {
        return this.conformidade(this.get(field), status, props);
    }

    get(field) {
        const value = _.get(this.data, field);

        return _.isNil(value) ? "" : value;
    }

    formatNumber(number, digits = 2) {
        const value = parseFloat(number);
        digits = !_.isNil(digits) ? digits : this.digits;

        if (_.isNaN(value)) {
            return "";
        } else {
            return value.toLocaleString("pt-br", {
                minimumFractionDigits: digits,
                maximumFractionDigits: digits,
            });
        }
    }

    formatDate(date) {
        try {

            return format(date, this.dateFormat);
        } catch (error) {
            return 'DATAERROR';

        }
    }

    tablePanel(colunas, linhas, props, tableProps) {

        const getValue = (c, l) => {
            if (c.getValue) {
                return c.getValue(l)
            }
            return _.get(l, c.field)
        }
        const getColor = (c, l) => {
            if (c.getColor) {
                return c.getColor(l)
            }
            return _.get(l, c.color)
        }
        let content = []

        content.push(this.row(...colunas.map(c => this.title(c.title))))
        if (linhas) {
            linhas.forEach(l => {
                content.push(this.row(...colunas.map(c => this.text(getValue(c, l), { ...c.propsField, fillColor: getColor(c, l) }))))
            })
        } else {
            content.push(this.row(...colunas.map(c => this.text(c.value, c.propsField))))
        }

        return this.panel(
            content,
            { widths: colunas.map(c => c.width || "*"), ...props },
            { headerRows: 1, ...tableProps }
        )
    }
}
